<template>
  <div class="contest-video" >
    <video-player   class="video-player vjs-custom-skin" style="width: inherit;width: inherit;"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                  @loadeddata="onloadeddata($event)"
                  @error="onError"
    ></video-player>
    <span class="close-video" @click="cancelVideo()" >
                <img src="../assets/images/cancel.png"/>
    </span>
  </div>
</template>

<script>
export default {
  name: 'h-video',
  data () {
    return {
      videoShow: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: '',
          src: ''
        }],
        poster: '', // 你的封面地址 暂无
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  // 全屏按钮
        }
      }
    }
  },
  methods: {
    onloadeddata () {
      // 播放按钮样式
      let videoPlayButton = document.querySelector('.vjs-big-play-button')
      videoPlayButton.setAttribute('id', 'm-small-play-button')
    },
    cancelVideo () {
      this.$emit('on-cancel')
    },
    onError () {
      this.$emit('on-error')
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
  .contest-video{
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 99;
    top:0;
  }
  .close-video{
    position: absolute;
    right: 16px;
    top: 10px;
    cursor: pointer;
    visibility: visible;
    opacity: 1;
    -webkit-transition: visibility 0.1s, opacity 0.1s;
    transition: visibility 0.1s, opacity 0.1s
  }
</style>



// WEBPACK FOOTER //
// src/components/h-video.vue